module.exports = __webpack_public_path__ + "static/ocean-robbins.2cd83699.jpg";